// The ordinary game and offline renderer use the same reproducible selector.
// Repo-local tracks keep a replay renderable when the music CDN is unavailable.
export function selectBattleMusic(manifest, seed, arenaKey = '') {
  const choices = (manifest || []).filter(entry => entry && entry.context === 'battle'
    && typeof entry.url === 'string' && !/^https?:/i.test(entry.url));
  if (!choices.length) return null;
  const key = `${Number(seed) >>> 0}|${String(arenaKey || '').toLowerCase()}`;
  let hash = 2166136261;
  for (let index = 0; index < key.length; index += 1) {
    hash ^= key.charCodeAt(index);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  return choices[hash % choices.length];
}
